const { formatMoney } = window.BAO.Utils
class AddHoops extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleOptionChange = this.handleOptionChange.bind(this)

    this.els.option?.elements.forEach((optionEl) => {
      this.listeners.add(optionEl, 'change', this.handleOptionChange)
    })

    this.addToCart = this.addToCart.bind(this)
    this.listeners.add(window, 'productAddedToCart', this.addToCart)
  }

  handleOptionChange (event) {
    const optionEl = event.target
    const productId = optionEl.getAttribute('data-add-hoops-product-id')
    const variantId = optionEl.getAttribute('data-add-hoops-variant-id')
    const optionPrice = optionEl.getAttribute('data-add-hoops-price')

    this.els.formVariantId.element.value = variantId
    this.els.formLastSelectedProductId.element.value = productId
    this.els.formProductId.element.value = productId

    setTimeout(() => {
      document.querySelector('site-drawers')?.closeDrawer()
    }, 300)

    this.updatePrice(optionPrice)
  }

  updatePrice (optionPrice) {
    this.externalEls.price?.elements.forEach((priceEl) => {
      const currentPrice = parseInt(priceEl.dataset.price)
      const combinedPrice = currentPrice + parseInt(optionPrice)

      priceEl.setAttribute('data-add-hoops-price', optionPrice)
      priceEl.textContent = formatMoney(combinedPrice)
    })
  }

  addToCart () {
    const variantId = this.els.formVariantId.element.value

    // Only add hoops to cart if a hoop variant has been selected
    if (!variantId || variantId === '') {
      return Promise.resolve()
    }

    return window.BAO.Cart.addItemFromForm(this.els.form.element)
  }
}

if (!customElements.get('add-hoops')) {
  customElements.define('add-hoops', AddHoops)
}
